export default {
  trafficPlanTemplateId: 'شناسه الگوی طرح ترافیک',
  courierPlanTemplateId: 'شناسه الگوی کاری پروژه'
}
